import { env } from "next-runtime-env";

// The locale list, its type and the env resolution live here — apart from
// routing.ts — precisely so this module has NO side effect on import: nothing
// runs until one of these functions is called. `next build` executes the
// top-level code of every module reachable from a page/layout while collecting
// page data, with no country env injected, so any module on that path must be
// import-safe. Consumers that only need the list/type (layout.tsx, request.ts)
// import from here, and routing.ts resolves the env behind a lazy getter.
//
// Each caller therefore triggers the throw at its own moment, all sharing this
// one implementation: routing.ts when the middleware expands its config
// (request time), request.ts inside the request-config callback (request time),
// global-error.tsx when it renders. Never at import time, never during a build.
export const locales = ["pt-BR", "es-CO"] as const;

export type Locale = (typeof locales)[number];

export function isValidLocale(value: string | undefined): value is Locale {
  return (locales as readonly string[]).includes(value ?? "");
}

export function resolveDefaultLocale(): Locale {
  const value = env("NEXT_PUBLIC_DEFAULT_LOCALE");
  if (!isValidLocale(value)) {
    throw new Error(
      `NEXT_PUBLIC_DEFAULT_LOCALE must be one of ${locales.join(", ")}, got: ${value}`,
    );
  }
  return value;
}
